(() => {
  const money = (cents, format) => {
    const value = (Number(cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: format || window.Shopify?.currency?.active || 'USD'
    });
    return value;
  };

  const menuButton = document.querySelector('.menu-toggle');
  const menu = document.querySelector('.main-nav');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-countdown-hours]').forEach((bar) => {
    const key = 'budss-countdown-end';
    const hours = Number(bar.dataset.countdownHours || 16);
    let end = Number(sessionStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 60 * 60 * 1000;
      sessionStorage.setItem(key, String(end));
    }
    const render = () => {
      const distance = Math.max(0, end - Date.now());
      const h = Math.floor(distance / 3600000);
      const m = Math.floor((distance % 3600000) / 60000);
      const s = Math.floor((distance % 60000) / 1000);
      bar.querySelector('[data-hours]').textContent = String(h).padStart(2, '0');
      bar.querySelector('[data-minutes]').textContent = String(m).padStart(2, '0');
      bar.querySelector('[data-seconds]').textContent = String(s).padStart(2, '0');
    };
    render();
    setInterval(render, 1000);
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const thumbs = [...section.querySelectorAll('[data-media-target]')];
    const media = [...section.querySelectorAll('[data-media-id]')];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.remove('is-active'));
        media.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        section.querySelector(`[data-media-id="${thumb.dataset.mediaTarget}"]`)?.classList.add('is-active');
      });
    });

    const form = section.querySelector('[data-product-form]');
    if (!form) return;

    const productJson = document.querySelector('[data-product-json]');
    const variants = productJson ? JSON.parse(productJson.textContent) : [];
    const optionSelects = [...form.querySelectorAll('[data-option-index]')];
    const idInput = form.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const saleBadge = section.querySelector('[data-product-sale-badge]');
    const addButton = form.querySelector('[data-add-button]');
    const addLabel = form.querySelector('[data-add-label]');
    const quantityInput = form.querySelector('[data-quantity]');
    const bundleCards = [...form.querySelectorAll('[data-bundle-card]')];
    const connectorPicker = form.querySelector('[data-connector-picker]');

    const selectedVariant = () => {
      if (!optionSelects.length) return variants.find((item) => String(item.id) === String(idInput?.value)) || variants[0];
      const selected = optionSelects.map((select) => select.value);
      return variants.find((item) => item.options.every((option, index) => option === selected[index]));
    };

    const renderBundleOffers = (variant = selectedVariant()) => {
      if (!variant) return;

      const unitPrice = Number(variant.price || 0);
      const compareAtPrice = Number(variant.compare_at_price || 0);
      const referenceUnitPrice = compareAtPrice > unitPrice ? compareAtPrice : unitPrice;

      bundleCards.forEach((card) => {
        const quantity = Number(card.dataset.bundleQuantity || 1);
        const configuredBundlePrice = Number(card.dataset.bundlePriceCents || 0);
        const bundlePrice = configuredBundlePrice > 0 ? configuredBundlePrice : unitPrice * quantity;
        const bundleComparePrice = referenceUnitPrice * quantity;
        const savings = Math.max(0, bundleComparePrice - bundlePrice);
        const savingsPercent = bundleComparePrice > 0 ? Math.round((savings / bundleComparePrice) * 100) : 0;
        const bundlePriceElement = card.querySelector('[data-bundle-price]');
        const bundleCompareElement = card.querySelector('[data-bundle-compare]');
        const bundleSaveAmount = card.querySelector('[data-bundle-save-amount]');
        const bundleSavePercent = card.querySelector('[data-bundle-save-percent]');

        if (bundlePriceElement) bundlePriceElement.textContent = money(bundlePrice);
        if (bundleCompareElement) {
          bundleCompareElement.hidden = bundleComparePrice <= bundlePrice;
          bundleCompareElement.textContent = money(bundleComparePrice);
        }
        if (bundleSaveAmount) {
          bundleSaveAmount.hidden = savings <= 0;
          bundleSaveAmount.textContent = savings > 0 ? `SAVE ${money(savings)}` : '';
        }
        if (bundleSavePercent && savings > 0) bundleSavePercent.textContent = `You save ${savingsPercent}%`;
      });
    };

    const placeConnectorPicker = (card) => {
      if (!connectorPicker || !card) return;
      const destination = card.querySelector('[data-bundle-details]');
      if (destination) destination.append(connectorPicker);
    };

    const updateVariant = () => {
      const variant = selectedVariant();
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      price.textContent = money(variant.price);
      if (variant.compare_at_price > variant.price) {
        const productSavings = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        comparePrice.hidden = false;
        comparePrice.textContent = money(variant.compare_at_price);
        if (saleBadge) {
          saleBadge.hidden = false;
          saleBadge.textContent = `SAVE ${productSavings}%`;
        }
      } else {
        comparePrice.hidden = true;
        if (saleBadge) saleBadge.hidden = true;
      }
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'ADD TO CART' : 'Sold out';
      renderBundleOffers(variant);
    };

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));

    form.querySelectorAll('input[name="bundle"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const selectedCard = radio.closest('[data-bundle-card]');
        bundleCards.forEach((card) => card.classList.remove('is-selected'));
        selectedCard?.classList.add('is-selected');
        if (quantityInput) quantityInput.value = radio.value;
        placeConnectorPicker(selectedCard);
      });
    });

    const initialSelectedCard = form.querySelector('input[name="bundle"]:checked')?.closest('[data-bundle-card]');
    placeConnectorPicker(initialSelectedCard);
    renderBundleOffers();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (addButton.disabled) return;
      addButton.disabled = true;
      addLabel.textContent = 'ADDING…';
      const body = new FormData(form);
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body
        });
        if (!response.ok) throw new Error('Cart error');
        const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        const toast = document.querySelector('[data-cart-toast]');
        toast?.classList.add('is-visible');
        setTimeout(() => toast?.classList.remove('is-visible'), 3500);
        addLabel.textContent = 'ADDED';
      } catch (error) {
        addLabel.textContent = 'TRY AGAIN';
      } finally {
        setTimeout(() => {
          addButton.disabled = false;
          addLabel.textContent = 'ADD TO CART';
        }, 1200);
      }
    });
  });

  document.querySelectorAll('[data-clip-sound]').forEach((button) => {
    button.addEventListener('click', () => {
      const video = button.closest('.action-clip')?.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      button.classList.toggle('is-on', !video.muted);
      button.setAttribute('aria-label', video.muted ? 'Turn video sound on' : 'Mute video');
    });
  });
})();
